import React, { useEffect, useState } from 'react'
import { Apiurl, parseData } from '../../Pages/utils/page'
import axios from 'axios'

const TopUsers = () => {
    const [topUsersData, setTopUsersData] = useState([])

    const GetTopUsers = () => {
        const loginToken = ""
        const option = {
            method: "GET",
            headers: {
                accept: '*/*',
                'Authorization': `Bearer ${loginToken ? loginToken : ""}`

            },
            url: `${Apiurl()}/api/Customer/TopReferrals`,
        };
        axios(option)
            .then((e) => {
                const data = parseData(e?.data?.result);
                setTopUsersData(data)
            })
            .catch((error) => {
            });
    }
    useEffect(() => {
        GetTopUsers()
    }, [])
    return (
        <div className="container" >
            <div className="referrals_tabs_data" >
                <div className="row" >
                    <div className="col-lg-12 mb_commn_pd_0" >
                    </div>
                </div>

                <div className="row" >
                    <div className="col-lg-12 mb_commn_pd_0" >
                       
                                <h4 className="common_heading" >
                                    Top Referrals Users</h4>
                            
                        <div >
                            <div className="table-responsive custom-table-01" >
                                <table className="table table-striped" >
                                    <thead >
                                        <tr >
                                            <th >#</th>
                                            <th >UserName</th>
                                            <th >ReferralCount</th>
                                        </tr>
                                    </thead>
                                    <tbody >
                                        {
                                            topUsersData?.map((item, index) => (
                                                <tr >
                                                    <td >{index+1}</td>
                                                    <td >{item?.UserName}</td>
                                                    <td >{item?.ReferralCount}</td>
                                                </tr>
                                            ))
                                        }

                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default TopUsers
